(function () {
  function initAccordions(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.accordion-item');
    items.forEach(function (item) {
      if (item.hasAttribute('data-accordion-init')) return;
      item.setAttribute('data-accordion-init', '');

      var details = item.querySelector('details');
      if (!details) return;
      var summary = details.querySelector('summary');
      if (!summary) return;

      function animateClose(d, callback) {
        if (!d.hasAttribute('open')) {
          if (callback) callback();
          return;
        }
        d.classList.remove('is-open');
        d.setAttribute('aria-expanded', 'false');
        var content = d.querySelector('.accordion__content');
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          d.removeAttribute('open');
          if (callback) callback();
        }
        setTimeout(finish, 350);
        if (content) {
          content.addEventListener('transitionend', function handler(evt) {
            if (evt.target !== content) return;
            content.removeEventListener('transitionend', handler);
            finish();
          });
        }
      }

      function animateOpen(d) {
        d.setAttribute('open', '');
        d.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function () {
          d.classList.add('is-open');
        });
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (details.hasAttribute('open')) {
          animateClose(details);
        } else {
          animateOpen(details);
        }
      });
    });
  }

  window.initAccordions = initAccordions;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAccordions();
    });
  } else {
    initAccordions();
  }
})();
